import React from "react";
import { connectUserStore } from "../../../hoc/connectStore/connectUserStore";
import {
  Box,
  Button,
  Divider,
  Menu,
  MenuItem,
  Typography,
} from "@material-ui/core";
import {
  AccountBalanceOutlined,
  AccountBalanceWalletOutlined,
  ArrowDropDown,
  DriveEtaOutlined,
  GavelOutlined,
  HomeOutlined,
  PeopleOutlined,
  PostAddOutlined,
  SettingsOutlined,
} from "@material-ui/icons";
import Wrapper from "../../../hoc/Wrapper/Wrapper";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";

const HeaderButton = (props) => {
  const [anchorEl1, setAnchorEl1] = React.useState(null);
  const [anchorEl2, setAnchorEl2] = React.useState(null);
  const [anchorEl3, setAnchorEl3] = React.useState(null);
  const [anchorEl4, setAnchorEl4] = React.useState(null);
  const [anchorE15, setAnchorE15] = React.useState(null);
  const [anchorE16, setAnchorE16] = React.useState(null);

  const dataMenu = {
    home: {
      title: "خانه",
      icon: <HomeOutlined />,
      children: null,
      anchor: false,
      setAnchorEl: null,
      url: "/",
    },
    cheque: {
      title: "چک ها",
      icon: <PostAddOutlined />,
      anchor: anchorEl1,
      setAnchorEl: setAnchorEl1,
      children: [
        {
          title: "افزودن چک",
          url: "/cheque/add",
        },
        {
          title: "لیست",
          url: "/cheque/list/all",
        },
        {
          title: "برگشتی",
          url: "/cheque/list/bounced",
        },
        {
          title: "عودتی ها",
          url: "/cheque/list/returned",
        },
        {
          title: "چک های پیش رو",
          url: "/cheque/list/future",
        },
        {
          title: "پاس شده ها",
          url: "/cheque/list/cashed",
        },
      ],
    },
    cheque_exit: {
      title: " خرید دین",
      icon: <GavelOutlined />,
      anchor: anchorEl2,
      setAnchorEl: setAnchorEl2,
      children: [
        {
          title: "افزودن خرید دین",
          url: "/cheque-contract/add",
        },
        {
          title: "لیست",
          url: "/cheque-contract/list",
        },
      ],
    },
    car_change: {
      title: " معاملات ماشین",
      icon: <DriveEtaOutlined />,
      anchor: anchorEl3,
      setAnchorEl: setAnchorEl3,
      children: [
        {
          title: "افزودن معامله ماشین",
          url: "/car-contract/add",
        },
        {
          title: "لیست",
          url: "/car-contract/list",
        },
      ],
    },
    debit_credit: {
      title: " بدهی و طلب",
      icon: <AccountBalanceWalletOutlined />,
      anchor: anchorEl4,
      setAnchorEl: setAnchorEl4,
      children: [
        {
          title: "افزودن بدهی وطلب",
          url: "/debit-credit/add",
        },
        {
          title: "لیست",
          url: "/debit-credit/list",
        },
      ],
    },
    bank: {
      title: "حساب بانکی",
      icon: <AccountBalanceOutlined />,
      anchor: anchorE15,
      setAnchorEl: setAnchorE15,
      children: [
        {
          title: "افزودن حساب بانکی",
          url: "/bank-account/add",
        },
        {
          title: "لیست",
          url: "/bank-account/list",
        },
      ],
    },
    person: {
      title: " اشخاص",
      icon: <PeopleOutlined />,
      anchor: anchorE16,
      setAnchorEl: setAnchorE16,
      children: [
        {
          title: "افزودن شخص",
          url: "/person/add",
        },
        {
          title: "افزودن مدیر",
          url: "/person/admin/add",
        },
        {
          title: "افزودن حقوقی",
          url: "/legal-entity/add",
        },
        {
          title: "لیست شخص ها",
          url: "/person/list",
        },
        {
          title: "لیست مدیران",
          url: "/person/admin/list",
        },
        {
          title: "لیست حقوقی ها",
          url: "/legal-entity/list",
        },
      ],
    },
    setting: {
      title: "تنظیمات",
      icon: <SettingsOutlined />,
      children: null,
      anchor: false,
      setAnchorEl: null,
      url: "/settings/list",
    },
  };

  const { classes } = props;

  const HeaderMenu = (title, icon, isChildren) => {
    return (
      <Box display={"flex"} style={{ paddingTop: "7px" }}>
        <div>{icon}</div>
        <div style={{ paddingRight: "10px" }}> {title}</div>
        <div>{isChildren != null ? <ArrowDropDown /> : null}</div>
      </Box>
    );
  };

  return (
    <Box className={classes.sectionDesktop}>
      {Object.keys(dataMenu).map((menuName, index) => {
        let menu = dataMenu[menuName];
        return (
          <Wrapper key={index}>
            <Button
              aria-controls="simple-menu"
              aria-haspopup="true"
              onClick={(event) => {
                if (!menu.children) props.history.push(menu.url);

                if (menu.anchor != false) {
                  menu.setAnchorEl(event.currentTarget);
                }
              }}
              className={classes.menutop}
            >
              {HeaderMenu(menu.title, menu.icon, menu.children)}
            </Button>
            {menu.children ? (
              <Menu
                id="simple-menu"
                anchorEl={menu.anchor}
                keepMounted
                open={Boolean(menu.anchor)}
                onClose={(event) => {
                  menu.setAnchorEl(null);
                }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
              >

                  <div style={{ display: "flex", paddingRight: "16px", padding: "8px 16px", color: "#01579b" }}>
                    <span>{menu.icon}</span>
                    <span style={{ marginRight: "8px" }}>{menu.title}</span>
                  </div>

                <Divider />
                {menu.children.map((menuSub, subIndex) => {
                  return (
                      <MenuItem
                        key={subIndex}
                        component={Link}
                        to={menuSub.url}
                        onClick={(event) => {
                          menu.setAnchorEl(null);
                        }}
                      >
                        {menuSub.title}
                      </MenuItem>
                  );
                })}
              </Menu>
            ) : null}
          </Wrapper>
        );
      })}
    </Box>
  );
};

export default connectUserStore(withRouter(HeaderButton));
